import React, { useState } from 'react';
import { Autocomplete } from '@react-google-maps/api';

const LocationSearch = ({ onLocationSelect, placeholder }) => {
  const [searchBox, setSearchBox] = useState(null);

  const onLoad = (autocomplete) => {
    setSearchBox(autocomplete);
  };

  const onPlaceChanged = () => {
    if (searchBox) {
      const place = searchBox.getPlace();
      if (place.geometry) {
        const location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          placeName: place.formatted_address
        };
        onLocationSelect(location);
      }
    }
  };

  return (
    <div className="relative w-full">
      <Autocomplete
        onLoad={onLoad}
        onPlaceChanged={onPlaceChanged}
      >
        <input
          type="text"
          placeholder={placeholder}
          className="w-full p-2 border rounded"
        />
      </Autocomplete>
    </div>
  );
};

export default LocationSearch; 